<template>
  <div>
    <el-dialog
      class="authorize-dialog"
      v-model="dialogVisible"
      title="提示"
      width="500"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="beforeclose"
      draggable
    >
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <h6>提示</h6>
        </div>
      </template>

      <div class="dialog-content" style="padding: 25px 15px 0">
        <h6>授权须知</h6>

        <div>
          <p>尊敬的经营主体:</p>
          <p style="text-align: justify">
            您好!欢迎您按时申报年度报告。为进一步方便经营主体年报，让数据多跑路、让经营主体少填报，北京市场监管局、国家税务总局北京税务局自2024年起实施“多报合一”改革，现请您对有关数据交换内容进行授权，授权后该年年报资产状况信息将无需手动填写，系统将智能共享税务报表相关信息。
          </p>
          <p>请您确认是否授权，同意授权请进行签字。</p>
        </div>

        <p>
          <el-form-item>
            <el-checkbox v-model="isCheck">已阅，并知晓</el-checkbox>
          </el-form-item>
        </p>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitForm" color="#d1ab62" style="color: #ffffff" size="large">确认授权</el-button>
          <el-button type="primary" @click="warn()" color="#d1ab62" style="color: #ffffff" size="large">拒绝授权</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from "element-plus";

const dialogVisible = ref(false);
const open = () => {
  dialogVisible.value = true;
};
const close = () => {
  dialogVisible.value = false;
};
const beforeclose = () => {
  isCheck.value = false;
};

const isCheck = ref(false);

const submitForm = () => {
  if (!isCheck.value) {
    ElMessage({
      message: "请先阅读授权须知内容",
      type: "warning",
    });
    return;
  }

  emits("submit");
};

const emits = defineEmits(["submit"]);
defineExpose({
  open,
  close,
});

//警告功能
function warn() {
  ElMessageBox.confirm("本系统为教学系统，暂不支持此功能", "信息", {
    showCancelButton: false,
    customStyle: {
      "--el-messagebox-width": "300px",
    },
  }).catch(() => {});
}
</script>

<style lang="scss" scoped>
:deep(.authorize-dialog) {
  padding: 0 !important;

  * {
    line-height: 1.5;
    font-family: "Microsoft YaHei";
  }

  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    margin: 0;
    padding: 0;
  }

  .dialog-header {
    height: 41px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(207, 169, 94);
    text-align: center;
    color: #ffffff;
    padding: 10px;
    position: relative;

    .dialog-header-btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);

      .el-icon {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dialog-content {
    > h6 {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
    }

    > div {
      > p {
        &:nth-of-type(1) {
          margin: 10px 0;
        }

        &:nth-of-type(3) {
          margin: 10px 0 30px;
        }
      }
    }

    > p {
      display: flex;
      justify-content: center;

      .el-form-item {
        margin: 0;

        .el-form-item__content .is-checked .el-checkbox__label {
          color: #d5b661 !important;
        }

        .el-form-item__content .is-checked .el-checkbox__inner {
          background-color: #d5b661 !important;
          border-color: #fff;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    padding: 30px 0 60px 0;
  }
}
</style>
